// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Setting__switch-fff821 {
  padding: 12px 16px;
  align-items: start;
}

.Setting__switch-fff821:active,
.Setting__switch-fff821:hover,
.Setting__switch-fff821:focus-visible {
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/Toolbar/Setting/SwitchCompactView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,kBAAA;AACF;;AAEA;;;EAGE,6BAAA;AACF","sourcesContent":[".switch {\n  padding: 12px 16px;\n  align-items: start;\n}\n\n.switch:active,\n.switch:hover,\n.switch:focus-visible {\n  background-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switch": `Setting__switch-fff821`
};
module.exports = ___CSS_LOADER_EXPORT___;
